module.exports = __webpack_public_path__ + "static/media/CelestialRealmBanquetDMGINTA0011_design_clean_v002.fdd8e326.webp";